import Button from "../../../common/button";
import BannerV1Wrapper from "./Banner.style";

const Banner = ({ item }) => {
  return (
    <BannerV1Wrapper id="home" item={item}>
      <div className="container">
        <div className="row">
          <div className="banner_main">
            <div className="col-lg-6">
              <div className="baner_left">
                <p>Treding Easy,Fast & Secure</p>
                <h2>
                  Buy & Trade on the Original <br />
                  <span>Marketplace</span>
                </h2>
                <p>
                  The first 1000 NFTs are available for minting now. <br />
                  Mint your NFT and join the community.
                </p>
                <div className="banner_buttons">
                  <Button lg variant="outline" >
                    {" "}
                    Get Started
                  </Button>
                  <Button lg variant="outline">
                    Learn More
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BannerV1Wrapper>
  );
};

export default Banner;
